import { qsmartApi } from '@/services/index';

const resource = process.env.VUE_APP_RESOURCE_SIRSIC_OCR_DCLI;

export default {
  read(payload) {
    return qsmartApi.post(resource, payload);
  },
};
